import styled from "styled-components";
import { RoundedBlock } from "./roundedBlock";

export const ErrorContainer = styled(RoundedBlock)`
	${({ theme }) => theme.textStyles.label};
	color: ${({ theme }) => theme.colors.red};
	border-color: ${({ theme }) => theme.colors.red};
	padding: 10px 15px;
	background-color: ${({ theme }) => theme.colors.lightRed};
	text-align: center;
`;
